module.exports = function scrollToErrors(className = '.message-to-read') {
    this.element = null;

    this.scrollNow = function () {
        this.element = jQuery(className);

        if (!this.element.length) {
            console.error(
                'Error triggered - but no element exists to display it.'
            );
        }

        if (!this.elementIsInView()) {
            jQuery('html, body').animate({
                scrollTop: this.element.offset().top - 30,
            });
        }
    };

    this.elementIsInView = function () {
        const minBoundry = window.scrollY;
        const maxBoundry = window.scrollY + window.innerHeight;

        return (
            this.element.offset().top > minBoundry &&
            this.element.offset().top < maxBoundry
        );
    };

};



// WEBPACK FOOTER //
// ./web/app/themes/giles/resources/js/components/scroll-to.js